import Pbp from 'components/general/Pbp'
import { DefaultRenderAthlete } from 'components/general/Pbp'
import Competitor from 'components/presentation/Competitor';
import SportCode from 'components/common/SportCode'
import Referees from 'components/general/Referees';
import Label from "components/general/Label";
import { useViewport } from 'components/general/useViewPort';
import { useUrlFriendlyToParameters } from "helpers/urlFriendly";

const Bk3CenterRender = ({ action }) => {
  let [a, b, c] = ['', '', ''];

  if (action.competitors === undefined) {
    a = <div className="score-horizontal-extra-information-box"><SportCode discipline='BK3' entity='@ActionComment' code={action?.pbpa_Comment} />&nbsp;</div>
  }

  if (!action?.pbpa_Comment?.includes('ENDP') && !action?.pbpa_Comment?.includes('STARTP')) {
    b = <div>{action?.pbpa_When}</div>
  }

  if (action.pbpa_ScoreH) {
    c = <div className="score-horizontal-extra-information-box"><strong>{action?.pbpa_ScoreH} - {action?.pbpa_ScoreA}</strong></div>
  }

  return (<div className='box-center text-center'><strong>{a}{b}{c}</strong></div>);
}

const Bk3RenderSide = ({ action, homeAway }) => {
  const { mirs_discipline } = useUrlFriendlyToParameters()
  const comp = action?.competitors?.find(item => item.pbpc_code === homeAway.participant?.code)

  if (!comp) return; //do nothing if there is no competitor related to the action

  return (
    <div className="box-BK3">
      <Bk3RenderCompetitor comp={comp} homeAway={homeAway} action={action} />
    </div>
  )
}

const Bk3RenderCompetitor = ({ comp, homeAway, action }) => {
  const { breakPoint } = useViewport()
  const { mirs_discipline } = useUrlFriendlyToParameters()
  if (comp.athletes) {
    return comp.athletes?.map((ath) => {
      return (
        <div key={action.pbpa_id + ath.pbpat_code}>
          <div className="d-flex flex-row flex-wrap">
            <span>{ath.pbpat_bib}</span>&nbsp;
            <span><DefaultRenderAthlete code={ath.pbpat_code} homeAway={homeAway} /></span>&nbsp;
            {action?.pbpa_Action === 'REB'
              ? <></>
              : <span><SportCode discipline={mirs_discipline} entity='@Action' code={action?.pbpa_Action} />&nbsp;</span>
            }
            {action?.pbpa_Action === 'CLG'
              ? breakPoint === "sm" || breakPoint === "xs"
                ? <>
                  <div className='w-50'>(<SportCode discipline={mirs_discipline} entity='@Challenge' code={action?.pbpa_ActionAdd} />)</div>&nbsp;
                  <div><Label data='HeaderChallengeRes' sport={mirs_discipline} />:&nbsp;</div>
                </>
                : <>
                  <div className='w-75'>(<SportCode discipline={mirs_discipline} entity='@Challenge' code={action?.pbpa_ActionAdd} />)</div>&nbsp;
                  <div><Label data='HeaderChallengeRes' sport={mirs_discipline} />:&nbsp;</div>
                </>
              : <></>
            }
            <span><SportCode discipline={mirs_discipline} entity='@ResAction' code={action?.pbpa_Result} /></span>&nbsp;
            {(action?.pbpa_Action === 'P1' || action?.pbpa_Action === 'P2') && action?.pbpa_ActionAdd && ath.pbpat_role !== 'ASSIST'
              ? <>({action?.pbpa_ActionAdd})</>
              : <></>
            }
            {(ath.pbpat_role === 'IN' || ath.pbpat_role === 'OUT' || ath.pbpat_role === 'ASSIST')
              ? <span><SportCode discipline={mirs_discipline} entity='@ActionRole' code={ath.pbpat_role} /></span>
              : <></>
            }
            {action?.pbpa_Action === 'FOUL'
              ? <>(<Label data='HeaderTeam' />:&nbsp;{action?.pbpa_ActionAdd})&nbsp;</>
              : <></>
            }

          </div>
        </div>
      );
    });
  } else {
    return (
      <div className='d-flex justify-content-start flex-wrap'>
        <Competitor hidePicture={true} alwaysNoc={true} {...homeAway?.participant} />&nbsp;
        <span><SportCode discipline={mirs_discipline} entity='@Action' code={action?.pbpa_Action} /></span>&nbsp;
        {action?.pbpa_Action === 'FOUL'
          ? <>(<Label data='HeaderTeam' />:&nbsp;{action?.pbpa_ActionAdd})&nbsp;</>
          : <></>
        }
        <span><SportCode discipline={mirs_discipline} entity='@ResAction' code={action?.pbpa_Result} /></span>
      </div>
    )
  }
}



function Bk3Pbp({ data, periodsOrder }) {

  const configPpb = {
    centerRender: Bk3CenterRender,
    sideRender: Bk3RenderSide,
    headerRender: () => { },
    layout: "points_left",
    periodsOrder: periodsOrder,
    reverseSorting: true
  }

  return (<>
    <Pbp data={data} config={configPpb} />
    <Referees data={data?.results?.officials} />
  </>);
}

export default Bk3Pbp;